import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface LessonDestroyApiOptions {
  disciplineId: string | number
  lessonId: number
  onStart?: () => void
  onFinish?: () => void
}

/** `DELETE /admin-api/disciplines/{discipline}/lessons/{booking}` — a finished lesson, or one whose task has a
 *  progress report, is refused with a message shown as the API words it. */
export const useLessonDestroyApi = async (options: LessonDestroyApiOptions): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.lessons.api.lesson', {
    discipline_id: options.disciplineId,
    lesson_id: options.lessonId,
  })

  options.onStart?.()

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    await $axios.delete<ApiResponse>(url)

    toast.success({
      title: 'Successfully deleted!',
      description: 'Lesson was successfully deleted!',
    })

    return true
  } catch (err: unknown) {
    toast.error({
      title: 'Error on delete!',
      description: getAxiosErrorMessage(err),
    })

    return false
  } finally {
    options.onFinish?.()
  }
}
